const title = '胡哩胡唠|日语学习网|查词|注音|语法|阅读|FuriFlow';

export const createPageTitle = (pageTitle: string) => {
  return `${pageTitle} - ${title}`;
};
